import { render } from "./ThinkTank.vue?vue&type=template&id=74347cf0"
import script from "./ThinkTank.vue?vue&type=script&lang=js"
export * from "./ThinkTank.vue?vue&type=script&lang=js"
script.render = render

export default script